import React from 'react';
import { Link } from 'react-router-dom'
import coupleImg1 from '../../images/couple/2.jpg'
import coupleImg2 from '../../images/couple/3.jpg'

import shape1 from '../../images/couple/shape-1.png'
import shape2 from '../../images/couple/shape-2.png'
import shape3 from '../../images/couple/shape-3.png'
import shape4 from '../../images/couple/shape-4.png'



const CoupleSection = (props) => {

    return (
        <section className={`couple-section section-padding ${props.cClass}`} id="couple">
            <div className="container">
                <div className="row align-items-center justify-content-center">
                    <div className="col col-lg-11">
                        <div className="couple-area clearfix">
                            <div className="couple-item bride">
                                <div className="row align-items-center">
                                    <div className="col-lg-4">
                                        <div className="couple-img">
                                            <img style={{
                                                objectFit: 'cover',
                                                aspectRatio: 1
                                            }} src={coupleImg1} alt="" />
                                            <div className="couple-shape">
                                                <img src={shape3} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-7">
                                        <div className="couple-text">
                                            <h3>María Martín</h3>
                                            <p>Si alguna vez te encuentras con un animal en apuros, seguramente yo ya estaré ahí con bata de veterinaria y una sonrisa lista para salvar el día.
                                                Amante de los retos, la buena comida y de meterme en reformas interminables (¡mi casa lo sabe!).
                                                Ahora estoy a punto de embarcarme en la mayor aventura de todas: el matrimonio, donde las recetas para sobrevivir no se encuentran en Google.
                                                ¿Listos para celebrar conmigo este gran día?</p>
                                            <div className="social">
                                                <ul>
                                                    {/* <li><Link to="/"><i className="ti-facebook"></i></Link></li> */}
                                                    {/* <li><Link to="/"><i className="ti-twitter-alt"></i></Link></li> */}
                                                    <li>
                                                        <a href="https://www.instagram.com/maria_ms16/" target="_blank" rel="noopener noreferrer"><i className="ti-instagram"></i></a>
                                                    </li>
                                                    {/* <li><Link to="/"><i className="ti-pinterest"></i></Link></li> */}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="couple-item groom">
                                <div className="row align-items-center">
                                    <div className="col-lg-7 order-lg-1 order-2">
                                        <div className="couple-text">
                                            <h3>Cristian Muñoz</h3>
                                            <p>Programador de profesión, ahora inmerso en la misión de terminar la obra del piso que acabamos de comprar (y descubriendo que siempre hay algo más por hacer).
                                                En casa, soy el chef oficial, probando recetas y llenando la cocina de aromas interesantes (y a veces, algún que otro desastre).
                                                También soy el encargado de esta web, porque si hay algo que me gusta, es combinar tecnología con momentos especiales.
                                                Estoy listo para celebrar este día increíble con todos vosotros. ¡Nos vemos en la boda!</p>
                                            <div className="social">
                                                <ul>
                                                    {/* <li><Link to="/"><i className="ti-facebook"></i></Link></li> */}
                                                    {/* <li><Link to="/"><i className="ti-twitter-alt"></i></Link></li> */}
                                                    <li>
                                                        <a href="https://www.instagram.com/cristianmr14/" target="_blank" rel="noopener noreferrer"><i className="ti-instagram"></i></a>
                                                    </li>
                                                    {/* <li><Link to="/"><i className="ti-pinterest"></i></Link></li> */}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 order-lg-2 order-1">
                                        <div className="couple-img">
                                            <img style={{
                                                objectFit: 'cover',
                                                aspectRatio: 1
                                            }} src={coupleImg2} alt="" />
                                            <div className="couple-shape">
                                                <img src={shape4} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="shape-1">
                <img src={shape1} alt="" style={{filter: 'grayscale(1)'}} />
            </div>
            <div className="shape-2">
                <img src={shape2} alt="" style={{filter: 'grayscale(1)'}} />
            </div>
        </section>

    );
}



export default CoupleSection;